import { useEffect } from 'react';
import { observable, reaction } from 'mobx';
import { noop } from '@src/utils/common-util';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { dispatchCustomEvent } from '@src/utils/custom-event';
class FooterStore {
  @observable isShowBackTop = false;
  @observable onBackTop = noop;

  constructor(options = {}) {
    const { onBackTop, ...rest } = options;
    this.onBackTop = onBackTop || noop;
    Object.assign(this, rest);
  }

  use() {
    useEffect(() => { }, []);

    useEffect(() => {
      window.OMNI__COMMON__FOOTER = {
        language_urls: [
          { title: 'English', websiteLink: '', code: 'en' },
          { title: '日本語', websiteLink: '', code: 'ja' },
          { title: '한국어', websiteLink: '', code: 'ko' },
          { title: '繁体中文', websiteLink: '', code: 'zh-Hant' },
          { title: 'ESPAÑOL', websiteLink: '', code: 'es' },
          { title: 'PORTUGUÊS', websiteLink: '', code: 'pt' },
          { title: 'DEUTSCH', websiteLink: '', code: 'de' },
          { title: 'FRANÇAIS', websiteLink: '', code: 'fr' },
          { title: 'РУССКИЙ', websiteLink: '', code: 'ru' },
          { title: 'ภาษาไทย', websiteLink: '', code: 'th' }
        ],
        to_top_handler: this.onBackTop,
        coookie_settings: function () {
          // 触发自定义事件，通知cookie-tips组件
          dispatchCustomEvent('omni:footer:cookie_settings');
        },
        currentLanguageCode: getLanguageByPath()
      };
      window.init_OMNI__COMMON__FOOTER();
      reaction(
        () => this.isShowBackTop,
        isShow => {
          const backTopButton = document.querySelector('#common_to_top_btn');
          if (!backTopButton) {
            return;
          }
          if (isShow) {
            backTopButton.style.display = 'block';
          } else {
            backTopButton.style.display = 'none';
          }
        }
      );
    }, []);
  }
}

export default FooterStore;
